<div class="content-container">
  <header class="header-container">
    <div class="labels-container">
      <div class="header-left-container">
        <span class="title">Creative Gallery</span>
        <div class="divider"></div>
        <div class="brand-container">
          <div class="logo">
            <img class="brand" [src]="brand?.icon" (error)="onIconError($event)" />
          </div>
          <span class="name"> {{brand?.label || ''}} </span>
        </div>
        <div class="divider"></div>
        <span class="name">
          <ng-container *ngIf="groupingType === 'themes'; else metricBucketLabel">{{ theme }} theme</ng-container>
          <ng-template #metricBucketLabel>{{ theme }}</ng-template>
        </span>
      </div>
      <button class="gray-button" (click)="close()">
        <img class="button-x" [src]="'svg/closeX.svg' | assetVersion" (error)="onIconError($event)" />
      </button>
    </div>
    <div class="bottom-divider"></div>
  </header>
  <app-creative-gallery #creativeGalleryComponent [data]="creativeGalleryData$().creativesData" [loading]="isLoading"
    [brandskeys]="[brandKey]" [getterName]="'getMessagingCreativeCard'" [isMessagingDrawer]="true"
    (requestPageChange)="onCreativeModalEdgeNav($event)"></app-creative-gallery>
  <div class="paginator-container">
    <app-paginator *ngIf="creativeGalleryData$().total" #creativeGalleryPaginator
      [length]="creativeGalleryData$().total" [pageSize]="CREATIVE_GALLERY_PAGE_SIZE" [initialPage]="initialPage"
      (page)="onCreativeGalleryPageChange($event)"></app-paginator>
  </div>
</div>